import api, { changeAuth } from './api';
import events from './events';
import user from './user';
import player from './player';
import liveSocial from './liveSocial';
import statistics from './statistics';
import invoice from './invoice';
import hotsites from './hotsites';
import { registerLog } from './logsAction';

export default {
  api,
  events,
  player,
  changeAuth,
  user,
  liveSocial,
  statistics,
  invoice,
  hotsites,
  registerLog,
};
